export default __webpack_public_path__ + "locales/si/DeleteDialog.json?hash=163faa86fa4d3ff5222bd1640baae4d4";